import { Link } from "react-router-dom";
import { YoutubeLogo } from "@phosphor-icons/react";
import { useLang } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-ink-800 px-6 py-16 md:px-10">
      <div className="mx-auto grid max-w-[1600px] gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-4">
            <img
              src="/logos/logo_footer.png"
              alt="Wall Board Academy"
              data-testid="footer-logo"
              className="h-24 w-24 object-contain"
            />
            <span className="font-head text-sm font-extrabold uppercase leading-none tracking-[0.18em] text-white">
              Wall Board<br /><span className="text-cyan">Academy</span>
            </span>
          </div>
          <p className="mt-6 max-w-xs font-body text-sm leading-relaxed text-slate-400">{t("footer_tag")}</p>
          <a
            href="https://www.youtube.com/@WallBoardAcademy"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-youtube-link"
            className="mt-5 inline-flex items-center gap-2 border border-cyan/40 bg-cyan/5 px-3 py-1.5 font-mono text-[10px] uppercase tracking-widest text-cyan transition-colors hover:bg-cyan hover:text-ink-900"
          >
            <YoutubeLogo size={14} weight="fill" /> @WallBoardAcademy
          </a>
        </div>

        <div className="flex flex-col gap-3">
          <p className="mb-2 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Library</p>
          <Link to="/library/video" className="font-body text-sm text-slate-300 hover:text-cyan">{t("video")}</Link>
          <Link to="/library/presentation" className="font-body text-sm text-slate-300 hover:text-cyan">{t("presentations")}</Link>
          <Link to="/library/other" className="font-body text-sm text-slate-300 hover:text-cyan">{t("other")}</Link>
        </div>

        <div className="flex flex-col gap-3">
          <p className="mb-2 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Organization</p>
          <p className="font-body text-sm text-slate-300">{t("organized")}</p>
          <p className="font-mono text-xs text-slate-500">www.wallboardacademy.com</p>
        </div>
      </div>
      <div className="mx-auto mt-14 max-w-[1600px] border-t border-white/5 pt-6">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
            © {new Date().getFullYear()} Wall Board Academy — All rights reserved
          </p>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 transition-colors hover:text-cyan"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}
